import { useState } from "react";
import { useMutation } from "@apollo/client";
import { UPDATE_GROUP_REFERENT_MUTATION } from "../graphql/groups.queries";
import useContextUrl from "@common/hooks/useContextUrl";

interface useUpdateGroupIsReferentProps {
  onSuccess?: () => void;
}

export type UpdateGroupIsReferentPayload = {
  groupId: string | number;
  isReferent: boolean;
};

type ReturnType = [
  { isLoading: boolean },
  (groups: UpdateGroupIsReferentPayload[]) => Promise<boolean>,
];

const useUpdateGroupIsReferent = (props?: useUpdateGroupIsReferentProps): ReturnType => {
  const { scenario, origin } = useContextUrl();
  const { onSuccess } = props ?? {};

  const [isLoading, setIsLoading] = useState(false);
  const [updateGroupIsReferentMutation] = useMutation(UPDATE_GROUP_REFERENT_MUTATION, {});

  const updateGroupIsReferent = async (
    groups: UpdateGroupIsReferentPayload[] = [],
  ): Promise<boolean> => {
    if (isLoading) {
      return;
    }

    try {
      setIsLoading(true);

      await Promise.all(
        groups.map(async group => {
          await updateGroupIsReferentMutation({
            variables: {
              originId: origin,
              scenarioId: scenario,
              groupId: group.groupId,
              isReferent: group.isReferent,
            },
          });
        }),
      );

      onSuccess?.();
      setIsLoading(false);
    } catch (e) {
      console.error(`Error updating group is referent: ${e}`);
      setIsLoading(false);
    }
  };

  return [{ isLoading }, updateGroupIsReferent];
};

export default useUpdateGroupIsReferent;
